import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

interface Label {
  box_name: string;
  box_number: string;
  pdf_url: string;
  tracking_number: string;
}

interface ShippingLabelsModalProps {
  labels: Label[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ShippingLabelsModal({ labels, open, onOpenChange }: ShippingLabelsModalProps) {
  if (!labels || labels.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Your Shipping Labels Are Ready!</DialogTitle>
          <DialogDescription>
            Labels have been emailed to you. You can also download them here.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 mt-4">
          {labels.map((label) => (
            <Card key={label.tracking_number}>
              <CardHeader>
                <CardTitle className="text-base">
                  {label.box_name} ({label.box_number})
                </CardTitle>
                <p className="text-sm text-muted-foreground">
                  Tracking: {label.tracking_number}
                </p>
              </CardHeader>
              <CardContent>
                <Button asChild>
                  <a href={label.pdf_url} download target="_blank" rel="noopener noreferrer">
                    <Download className="w-4 h-4 mr-2" />
                    Download PDF Label
                  </a>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
